import {
  LoginAction,
  LoginState,
  ResultAction,
  ResultState,
  SearchAction,
  SearchState,
  SelectAction,
  SelectState,
  SubscriptionHistoryState,
  CustomerHistoryState,
  CustomerHistoryAction,
  SubscriptionHistoryAction,
  GiftCardAction,
  GiftCardState,
  ForgotPasswordAction,
  ForgotPasswordState,
  EnterCodeState,
  EnterCodeAction,
  AdvanceResultState,
  AdvanceResultAction,
  RsAdminResultState,
  RsAdminResultAction
} from "./types";

export const setCredentials = (payload: LoginState): LoginAction => ({
  type: "LOGIN",
  payload,
});

export const setForgotPassword = (payload: ForgotPasswordState): ForgotPasswordAction => ({
  type: "FORGOT_PASSWORD",
  payload,
});

export const setEnterCode = (payload: EnterCodeState): EnterCodeAction => ({
  type: "ENTER_CODE",
  payload,
});

export const setSearch = (payload: SearchState): SearchAction => ({
  type: "SEARCH",
  payload,
});

export const setResult = (payload: ResultState): ResultAction => ({
  type: "RESULT",
  payload,
});

export const setSelect = (payload: SelectState): SelectAction => ({
  type: "SELECT",
  payload,
});

export const setUserHistory = (payload: CustomerHistoryState): CustomerHistoryAction => ({
  type: "USER_HISTORY",
  payload,
});
export const setSubHistory = (payload: SubscriptionHistoryState): SubscriptionHistoryAction => ({
  type: "SUB_HISTORY",
  payload,
});

export const setGiftCard = (payload: GiftCardState): GiftCardAction => ({
  type: "GIFT_CARD",
  payload,
});
export const setAdvanceResult = (payload: AdvanceResultState): AdvanceResultAction => ({
  type: "ADVANCE_RESULT",
  payload,
});

export const setRsAdminResult = (payload: RsAdminResultState): RsAdminResultAction => ({
  type: "RS_ADMIN_RESULT",
  payload,
});